import { jsx as _jsx } from "react/jsx-runtime";
export const StructuredData = ({ productUrl, productFullName, profileName, reviewBody, datePublished, reviewRating, pros, cons, }) => {
    const [date] = datePublished.split('T');
    const structure = {
        '@context': 'https://schema.org/',
        '@type': 'Review',
        itemReviewed: {
            '@type': 'Product',
            name: productFullName,
            url: productUrl,
        },
        author: {
            '@type': 'Person',
            name: profileName,
        },
        publisher: {
            '@type': 'Organization',
            name: 'Coolblue',
        },
        reviewBody: reviewBody,
        datePublished: date,
        positiveNotes: pros,
        negativeNotes: cons,
    };
    if (+reviewRating !== 0) {
        structure.reviewRating = {
            '@type': 'Rating',
            ratingValue: reviewRating,
            worstRating: '1',
            bestRating: '10',
        };
    }
    return (_jsx("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
            __html: JSON.stringify(structure),
        } }));
};
//# sourceMappingURL=StructuredData.js.map